var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSquareTerminal = function SvgSquareTerminal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    "data-name": "Layer 1",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.874 17.955a.5.5 0 0 1-.354-.853l4.041-4.041a1.5 1.5 0 0 0 0-2.121L4.52 6.898a.5.5 0 0 1 .707-.707l4.041 4.041a2.5 2.5 0 0 1 0 3.535l-4.041 4.041a.5.5 0 0 1-.354.146ZM24 19.5v-15C24 2.019 21.981 0 19.5 0h-15A4.505 4.505 0 0 0 0 4.5v15C0 21.981 2.019 24 4.5 24h15c2.481 0 4.5-2.019 4.5-4.5M19.5 1C21.43 1 23 2.57 23 4.5v15c0 1.93-1.57 3.5-3.5 3.5h-15C2.57 23 1 21.43 1 19.5v-15C1 2.57 2.57 1 4.5 1zm.5 16.5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 .5-.5"
  })));
};
export default SvgSquareTerminal;